import type { Game, Member } from '../../types/game'
import { ResourceIcon } from '../shared/ResourceIcon'
import { assetUrl } from '../../utils/assets'

interface DonationResponseModalProps {
  game: Game
  members: Member[]
  onAccept: () => void
  onReject: () => void
}

export function DonationResponseModal({ game, members, onAccept, onReject }: DonationResponseModalProps) {
  const pending = game.pending_donation
  if (!pending) return null

  const donorMember = members.find((member) => member.color === pending.donor)
  const headerText = `${donorMember?.alias ?? pending.donor} wants to donate:`
  const canReject = game.donation_mode === 'refusable'

  const offerChildren = pending.offer.donations.map((donation, index) => (
    <div key={`${donation.resource}-${index}`} className="donation-receiving-offer">
      <div>{donation.n}</div>
      <ResourceIcon resource={donation.resource as any} />
    </div>
  ))

  return (
    <div className="donation-receiving-modal-root">
      <div className="donation-receiving-overlay" onClick={canReject ? onReject : undefined} />
      <div className="donation-receiving-container">
        <div className="donation-receiving tableau">
          <div className="donation-receiving-content desktop-shell-view">
            <div className="donation-receiving-column">
              <div className="donation-receiving-header">
                <div className="donation-receiving-title">Donation</div>
                <div className="donation-receiving-description">{headerText}</div>
              </div>
              <img src={assetUrl('images', 'donation.png')} alt="" />
            </div>
            <div className="donation-receiving-column">
              <div className="donation-receiving-body-container">
                <div className="mobile-modal-close-row">
                  <div
                    id="donation-receiving-close"
                    className="mobile-modal-close lobby-start"
                    onClick={canReject ? onReject : undefined}
                  >
                    Close
                  </div>
                </div>
                <div className="donation-receiving-body">{offerChildren}</div>
                <div className="donation-receiving-actions">
                  {canReject ? (
                    <div id="donation-receiving-reject" className="donation-receiving-reject" onClick={onReject}>
                      Reject
                    </div>
                  ) : null}
                  <div id="donation-receiving-accept" className="donation-receiving-accept" onClick={onAccept}>
                    Accept
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="donation-receiving-mobile-shell mobile-shell-view">
            <div className="mobile-modal-shell donation-receiving-mobile-card">
              <div className="mobile-modal-header">
                <div className="mobile-modal-title">Donation</div>
                <div
                  id="donation-receiving-mobile-close"
                  className="mobile-modal-close-button lobby-start"
                  onClick={canReject ? onReject : undefined}
                >
                  Close
                </div>
              </div>
              <div className="mobile-modal-hero donating-mobile-hero">
                <img src={assetUrl('images', 'donation.png')} alt="" />
              </div>
              <div className="mobile-modal-section">
                <div className="mobile-modal-section-title">Incoming Offer</div>
                <div className="donation-receiving-mobile-body">{offerChildren}</div>
              </div>
              <div className="mobile-modal-footer">
                {canReject ? (
                  <div id="donation-receiving-mobile-reject" className="donation-receiving-reject" onClick={onReject}>
                    Reject
                  </div>
                ) : null}
                <div id="donation-receiving-mobile-accept" className="donation-receiving-accept" onClick={onAccept}>
                  Accept
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
